<!-- Bottom Navigation — mobile only (hidden on sm+) -->
<nav
    class="fixed bottom-0 left-0 right-0 z-50 sm:hidden bg-white/95 dark:bg-stone-800/95 backdrop-blur-xl border-t border-grounded/20 dark:border-stone-700/30 shadow-2xl">
    <div class="flex items-stretch h-16">
        @for (item of visibleNavItems(); track item.route) {
        <a [routerLink]="item.route"
            class="flex-1 flex flex-col items-center justify-center gap-0.5 px-1 py-2 transition-all duration-200 relative group"
            [class.text-soulfire]="isActive(item.route)" [class.dark:text-fuchsia-400]="isActive(item.route)"
            [class.text-rooted]="!isActive(item.route)" [class.dark:text-stone-400]="!isActive(item.route)"
            [attr.aria-label]="item.label">
            <!-- Active Indicator -->
            @if (isActive(item.route)) {
            <span
                class="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-gradient-to-r from-soulfire to-bloom dark:from-fuchsia-500 dark:to-fuchsia-400 rounded-full"></span>
            }

            <!-- Icon -->
            <i [ngClass]="item.icon" class="text-xl transition-transform duration-200"
                [class.scale-110]="isActive(item.route)"></i>

            <!-- Label -->
            <span class="text-[10px] font-medium leading-none truncate w-full text-center">
                {{ item.label }}
            </span>
        </a>
        }
    </div>
</nav>